export const isFile = (value: File | string): value is File => value && typeof value !== "string" && "name" in value
